import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ReactPixel from 'react-facebook-pixel';
import TagManager from 'react-gtm-module';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import MenuIcon from '@material-ui/icons/Menu';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';

import Header from '../../Header';
import Unavailability from '../../../../components/Unavailability';
import Body from '../../Body';
import Footer from '../../Footer';
import Detail from '../../../Detail';
import OrderButton from '../../../../components/OrderButton';
import Order from '../../../Order';
import Addresses from '../../../Addresses';
import Payments from '../../../Payments';
import Success from '../../../Success';
import { Pix } from '../../../Pix';

import { Container } from './styles';
import { TabPanel } from '../../../../components/TabPanel';
import { Orders } from '../../../Orders';
import { pageview } from '../../../../services/application';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const pixelId = process.env.REACT_APP_PIXEL_ID;
const accessToken = process.env.REACT_APP_PIXEL_ACCESS_TOKEN;
const tag = process.env.REACT_APP_GTM_ID;

function AfterLoading() {
  const location = useLocation();
  const [pageView, setPageView] = useState(true);
  const [tab, setTab] = useState('menu');
  const { company } = useSelector(state => state.data);
  const { order } = useSelector(state => state.order);

  useEffect(() => {
    if (pageView) {
      if (pixelId && accessToken) {
        const eventId = 'event_' + Date.now();
        const options = {
          autoConfig: true,
          debug: false,
        };
        ReactPixel.init(pixelId, {}, options);
        ReactPixel.track('PageView', { eventID: eventId });
        pageview({
          eventSourceUrl: window.location.origin,
          eventId,
          pixelId,
          accessToken,
        });
      }
      if (tag) {
        TagManager.dataLayer({
          dataLayer: {
            event: 'PageView',
            url: window.location.origin + location.pathname + location.search,
            page: location.pathname + location.search,
            pageTitle: document.title,
          },
        });
      }
      setPageView(false);
    }
  }, [pageView, location]);

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <Container>
      <TabPanel value={tab} index="menu">
        <Header background={company.background} />
        <Unavailability />
        <Body />
        <Footer />
        {order && order.items && order.items.length >= 1 && <OrderButton />}
        <Detail />
        <Order />
        <Addresses />
        <Payments />
        <Success />
        <Pix />
      </TabPanel>
      <TabPanel value={tab} index="orders">
        <Orders />
      </TabPanel>
      <AppBar
        position="fixed"
        color="default"
        style={{ top: 'auto', bottom: 0 }}
      >
        <Tabs
          value={tab}
          onChange={handleChange}
          variant="fullWidth"
          indicatorColor="secondary"
        >
          <Tab value="menu" icon={<MenuIcon />} label="MENU" />
          <Tab
            value="orders"
            icon={<DescriptionOutlinedIcon />}
            label="PEDIDOS"
          />
        </Tabs>
      </AppBar>
    </Container>
  );
}

export { AfterLoading };
